'use strict';
module.exports = function () {
	return /\u001b\[(?:[0-9]{1,3}(?:;[0-9]{1,3})*)?[m|K]/g;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/jsondiffpatch/~/ansi-regex/index.js
 ** module id = 435
 ** module chunks = 0
 **/